
<template>
  <div class="box" ref="box">
    
    <div class="rewarding-option">
      <div class="top-ctrl">
        <i class="icon icon-close-range" @click="closeRewardOption"></i>            
      </div>
      <div class="reward-num">
        <div class="input-num">
          <input v-model="rewardNum" type="number" name="" :placeholder="getDict(77)">
        </div>
        <div class="default-num">
          <div class="value" @click="()=>{rewardNum = item.value}" v-for="(item,index) in defaultNum">{{item.name}}</div>
        </div>
      </div>
      <div class="submit" @click="submitReward">{{getDict(76)}}</div>
    </div>

    <div class="float-box" v-if="popTips">
      <div class="pop-tips" v-if="popTips">
        <div class="ctrl">
          <i class="icon icon-close-range" @click="popTips = ''"></i>
        </div>
        <div class="text">{{popTips}}</div>
      </div>
    </div>
    
  </div>
  
</template>

<script>

  import { bus, getDict, axios, webSocket  } from '../common'
  import { mapState, mapGetters } from 'vuex'

  

  export default {
    props: {
      channelId:{},
    },
    data(){
      return {
        rewardNum:'',
        defaultMap:[
          {
            name:'100',
            value:100,
          },
          {
            name:'1000',
            value:1000,
          },
          {
            name:'10000',
            value:10000,
          },
          {
            name:'All in',
            value:'All in',
          }
        ],
        popTips:'',
      }
    },
    computed:{
      ...mapState(['userData','goingTime']),
      defaultNum(){
        return this.defaultMap.map((node)=>{
          if(typeof node.value == 'string'){
            return {
              ...node,
              value:this.userData.money,
            }
          }
          return node;
        })
      },
    },
    watch:{
    },
    components: {
    },
    methods: {
      getDict,
      async submitReward(){
        console.log(123)
        if(+this.rewardNum > this.userData.money){
          this.popTips = getDict(79);
          return;
        }
        if(+this.rewardNum < 0 || !+this.rewardNum){
          this.popTips = getDict(77);
          return;
        }
        try{
          await webSocket.get('/user/reward',{
            channelId: this.channelId,
            money: +this.rewardNum
          });
          this.popTips = getDict(78);
          setTimeout(()=>{
            this.closeRewardOption()
          },3 * 1000)
        }catch(res){
          if(res.err_msg.indexOf('no enough money') != -1){
            this.popTips = getDict(79);
          }
        }
        this.$store.dispatch('getUserData');
      },
      closeRewardOption(){
        this.rewardNum = '';
        this.$emit('close')
      },
    },
    mounted(){
    },
    created(){
    },
    beforeDestroy(){
    }
  }
</script>

<style lang="scss" scoped>
  .box{
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: rgba(40,40,40,1);
    // padding: 0.1rem;
    // padding-bottom:0;
    position: relative;
    

    .rewarding-option{
      // background-color: #000;
      height: 100%;
      .top-ctrl{
        $size:0.25rem;
        height: $size;
        padding: 0.1rem;
        .icon{
          float: right;
          width:$size;
          height: $size;
        }
      }
      .title{
        margin:0.2rem 0.1rem 0;
        // margin-top: 0.2rem;
        text-align: center;
        color: #fff;
        font-size: 0.18rem;
        letter-spacing:0.02rem;
        font-weight: 600;
        padding: 0.1rem 0;
        border-bottom: 1px solid #444;
      }
      .select-option{
        background-color: #000;
        color: #ffc952;
        text-align: center;
        font-size: 0.22rem;
        padding: 0.08rem 0 0.1rem
      }

      .reward-num{
        // background-color: #3d3d3d;
        padding: 0.1rem;
        .input-num{
          border-bottom: 1px solid #555;
          // border-bottom: 1px solid #8b8b8b;
          padding-bottom: 0.1rem;
          input{
            width: 100%;
            border: none;
            background: none;
            color: #8b8b8b;
            text-align:center;
            font-size: 0.25rem;

            .lang-jp & {
            }
            .lang-en & {
              font-size: 0.2rem;
            }
          }
        }
        .default-num{
          margin-top: 0.1rem;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .value{
            $font-size: 0.2rem;
            width: 45%;
            background-color:#6f6f70;
            border-radius: 1rem; 
            text-align: center;
            margin:0.1rem 0;
            font-size: $font-size;
            line-height: $font-size * 1.5
          }
        }
        .can-get{
          font-size: 0.2rem;
          font-weight: 600;
          margin: 0.1rem 0;
          text-align:center;
          .text{
            margin-right: 0.1rem;
          }
          .value{
            color: #ffc952;
          }
        }
      }

      .submit{
        width: 90%;
        margin: 0.2rem auto;
        background: url(../assets/gamble-submit-btn.png) no-repeat center center;
        background-size: 100% 100%;
        $font-size:0.25rem;
        font-size: $font-size;
        line-height: $font-size * 2;
        text-align: center;
        color: #000; 
      }
    }

    .float-box{
      position: absolute;
      width: 100%;
      height: 100%; 
      display: flex;
      align-items: center;
      left: 0;

      .pop-tips{
        background: rgba(0,0,0,0.8);
        color: #fff;
        text-align: center;
        padding: 0.1rem;
        line-height: 0.3rem;
        width: 100%;
        .ctrl{
          display: flex;
          justify-content: flex-end;
          margin-bottom: 0.1rem;
        }
        .text{
          font-size: 0.2rem;
        }
        
      }
      
    }
    


    
    
  }
</style>
